import { IList, useNavigator, useStreamValue } from 'annotation-tools/utils';
import { useCallback, useEffect, useRef } from 'react';
import {
  companyId$,
  koumutenId$,
  modelId$
} from '../../../../global-state/router-id';
import { routes } from '../../../../routing/routes';
import { IImageInfoType } from '../../../../types/record/image-info';

export const useHandlers = (imageList: IList<IImageInfoType>) => {
  const navigator = useNavigator();
  const koumutenId = useStreamValue(koumutenId$);
  const companyId = useStreamValue(companyId$);
  const modelId = useStreamValue(modelId$);

  const ref = useRef<{
    navigator: undefined | ((pathname: string) => void);
    koumutenId: undefined | number;
    companyId: undefined | number;
    modelId: undefined | number;
    imageList: undefined | IList<IImageInfoType>;
  }>({
    navigator: undefined,
    koumutenId: undefined,
    companyId: undefined,
    modelId: undefined,
    imageList: undefined
  });

  useEffect(() => {
    ref.current = {
      navigator,
      koumutenId,
      companyId,
      modelId,
      imageList
    };
  }, [navigator, koumutenId, companyId, modelId, imageList]);

  const onPageIndexChange = useCallback((pageIndex: number) => {
    const rf = ref.current;
    if (
      pageIndex === undefined ||
      rf.koumutenId === undefined ||
      rf.companyId === undefined ||
      rf.modelId === undefined ||
      rf.imageList === undefined ||
      rf.navigator === undefined ||
      pageIndex < 0 ||
      rf.imageList.size < pageIndex
    ) {
      return;
    }
    const nextImageId = rf.imageList.get(pageIndex)?.id;
    if (nextImageId === undefined) return;

    rf.navigator(
      routes.modelImageRoot(
        rf.koumutenId,
        rf.companyId,
        rf.modelId,
        nextImageId
      )
    );
  }, []);

  const onBackToListPageClick = useCallback(() => {
    const rf = ref.current;
    if (
      rf.koumutenId !== undefined &&
      rf.companyId !== undefined &&
      rf.modelId !== undefined &&
      rf.navigator !== undefined
    ) {
      rf.navigator(
        routes.modelImageList(rf.koumutenId, rf.companyId, rf.modelId)
      );
    }
  }, []);

  return { onPageIndexChange, onBackToListPageClick };
};
